import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export default new Router({
    routes: [
        {
            path: '/',
            redirect: '/login'
        },
        {
            path: '/home',
            component: () => import(/* webpackChunkName: "home" */ '../components/common/Home.vue'),
            meta: { title: '商户管理' },
            children: [ {
                path: '/dashboard',
                component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/Dashboard.vue'),
                meta: { title: '系统首页' },
            },{
                path:'/installSuper',
                component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/Install.vue'),
                meta: { title: '设置' },
            },{
                path:'/Merchant',
                component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/Merchant.vue'),
                meta: { title: '门店管理' },
            },{
                path:'/Manage',
                component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/Manage.vue'),
                meta: { title: '管理员管理' },
            },{
                // 国际化组件
                path: '/i18n',
                component: () => import(/* webpackChunkName: "i18n" */ '../components/page/I18n.vue'),
                meta: { title: '国际化' }
            },
            {
                // 权限页面
                path: '/permission',
                component: () => import(/* webpackChunkName: "permission" */ '../components/page/Permission.vue'),
                meta: { title: '权限测试', permission: true }
            },{
                // 国际化组件
                path: '/addCompany',
                component: () => import(/* webpackChunkName: "i18n" */ '../components/page/Company/AddCompany'),
                meta: { title: '编辑公司' }
            },
            {
                path: '/404',
                component: () => import(/* webpackChunkName: "404" */ '../components/page/404.vue'),
                meta: { title: '404' }
            },
            {
                path: '/403',
                component: () => import(/* webpackChunkName: "403" */ '../components/page/403.vue'),
                meta: { title: '403' }
            },
        ]
        },
        {
            path: '/homeNext',
            component: () => import(/* webpackChunkName: "home" */ '../components/common/HomeNext.vue'),
            redirect: '/dashboardNext',
            meta: { title: '商户' },
            children: [
                {
                    path: '/dashboardNext',
                    component: () => import(/* webpackChunkName: "dashboard" */ '../components/page/DashboardNext.vue'),
                    meta: { title: '商户首页' }
                },
                {
                    path: '/noticeCate',
                    component: () => import(/* webpackChunkName: "icon" */ '../components/page/Notice/NoticeCate.vue'),
                    meta: { title: '关于我们' }
                },
                {
                    path: '/companyIntro',
                    component: () => import(/* webpackChunkName: "table" */ '../components/page/Notice/CompanyIntro.vue'),
                    meta: { title: '企业简介' }
                },
                {
                    path: '/notice',
                    component: () => import(/* webpackChunkName: "table" */ '../components/page/Notice/Notice.vue'),
                    meta: { title: '企业公告' }
                },
                {
                    path: '/companyInfo',
                    component: () => import(/* webpackChunkName: "table" */ '../components/page/Notice/CompanyInfo.vue'),
                    meta: { title: '企业动态' }
                },
                {
                    path: '/company',
                    component: () => import(/* webpackChunkName: "form" */ '../components/page/Company/Company.vue'),
                    meta: { title: '公司类别管理' }
                },
                {
                    path: '/sealShape',
                    component: () => import(/* webpackChunkName: "markdown" */ '../components/page/Company/SealShape.vue'),
                    meta: { title: '公章形状管理' }
                },
                {
                    path: '/finiceWithdrawal',
                    component: () => import(/* webpackChunkName: "markdown" */ '../components/page/Withdrawal/finiceWithdrawal.vue'),
                    meta: { title: '财务公司提现审核' }
                },
                {
                    path: '/userWithdrawal',
                    component: () => import(/* webpackChunkName: "markdown" */ '../components/page/Withdrawal/userWithdrawal.vue'),
                    meta: { title: '员工提现审核' }
                },
                {
                    path: '/applyWithdrawal',
                    component: () => import(/* webpackChunkName: "markdown" */ '../components/page/Withdrawal/applyWithdrawal.vue'),
                    meta: { title: '申请提现' }
                },
                {
                    path: '/financeCode',
                    component: () => import(/* webpackChunkName: "markdown" */ '../components/page/Company/FinanceCode.vue'),
                    meta: { title: '财务公司二维码' }
                },
                {
                    path: '/setword',
                    component: () => import(/* webpackChunkName: "markdown" */ '../components/page/Company/setWord.vue'),
                    meta: { title: '修改密码' }
                },
                {
                    path: '/finiceUser',
                    component: () => import(/* webpackChunkName: "markdown" */ '../components/page/User/FiniceUser.vue'),
                    meta: { title: '旗下用户' }
                },
                {
                    path: '/sealCate',
                    component: () => import(/* webpackChunkName: "markdown" */ '../components/page/Company/SealCate.vue'),
                    meta: { title: '公章类别管理' }
                },
                {
                    path: '/financeCompany',
                    component: () => import(/* webpackChunkName: "markdown" */ '../components/page/Company/FinanceCompany.vue'),
                    meta: { title: '财务公司' }
                },
                {
                    path: '/empaccount',
                    component: () => import(/* webpackChunkName: "markdown" */ '../components/page/Company/Empaccount.vue'),
                    meta: { title: '员工账号' }
                },
                {
                    path: '/sealMaterial',
                    component: () => import(/* webpackChunkName: "markdown" */ '../components/page/Company/SealMaterial.vue'),
                    meta: { title: '公章材料管理' }
                },
                {
                    path: '/seal',
                    component: () => import(/* webpackChunkName: "editor" */ '../components/page/Company/Seal.vue'),
                    meta: { title: '公章管理' }
                },
                {
                    path: '/userAddress',
                    component: () => import(/* webpackChunkName: "chart" */ '../components/page/User/UserAddress.vue'),
                    meta: { title: '用户地址管理' }
                },
                {
                    path: '/user',
                    component: () => import(/* webpackChunkName: "upload" */ '../components/page/User/User.vue'),
                    meta: { title: '用户管理' }
                },
                {
                    path: '/worker',
                    component: () => import(/* webpackChunkName: "upload" */ '../components/page/User/Worker.vue'),
                    meta: { title: '员工管理' }
                },
                {
                    path: '/install',
                    component: () => import(/* webpackChunkName: "chart" */ '../components/page/Install/Insatall.vue'),
                    meta: { title: '设置管理' }
                },
                {
                    path: '/sealArea',
                    component: () => import(/* webpackChunkName: "drag" */ '../components/page/SealApply/SealArea.vue'),
                    meta: { title: '公章申请区域管理' }
                },
                {
                    path: '/sealApply',
                    component: () => import(/* webpackChunkName: "drag" */ '../components/page/SealApply/SealApply.vue'),
                    meta: { title: '公章申请管理' }
                },
                {
                    path: '/fiSealApply',
                    component: () => import(/* webpackChunkName: "drag" */ '../components/page/SealApply/FiSealApply.vue'),
                    meta: { title: '公章订单' }
                },
                {
                    path: '/applyReason',
                    component: () => import(/* webpackChunkName: "drag" */ '../components/page/SealApply/ApplyReason.vue'),
                    meta: { title: '申请理由' }
                },
                {
                    path: '/advertPosition',
                    component: () => import(/* webpackChunkName: "drag" */ '../components/page/Advert/AdvertPosition.vue'),
                    meta: { title: '广告位置' }
                },
                {
                    path: '/advert',
                    component: () => import(/* webpackChunkName: "drag" */ '../components/page/Advert/Advert.vue'),
                    meta: { title: '广告管理' }
                },
                {
                    path: '/file',
                    component: () => import(/* webpackChunkName: "drag" */ '../components/page/File/File.vue'),
                    meta: { title: '文件上传管理' }
                },
                {
                    // 国际化组件
                    path: '/i18n',
                    component: () => import(/* webpackChunkName: "i18n" */ '../components/page/I18n.vue'),
                    meta: { title: '国际化' }
                },
                {
                    // 权限页面
                    path: '/permission',
                    component: () => import(/* webpackChunkName: "permission" */ '../components/page/Permission.vue'),
                    meta: { title: '权限测试', permission: true }
                },
                {
                    path: '/404',
                    component: () => import(/* webpackChunkName: "404" */ '../components/page/404.vue'),
                    meta: { title: '404' }
                },
                {
                    path: '/403',
                    component: () => import(/* webpackChunkName: "403" */ '../components/page/403.vue'),
                    meta: { title: '403' }
                },
            ]
        },
        {
            path: '/login',
            component: () => import(/* webpackChunkName: "login" */ '../components/page/Login.vue'),
            meta: { title: '登录' }
        },
        {
            path: '*',
            redirect: '/404'
        },
    

    ]
});
